import React, {useEffect, useRef, useState} from 'react'
import Select from 'react-select'
import {KTIcon, KTSVG} from '../../../_metronic/helpers'
import {useFormik} from 'formik'
import {affectReseauClient, getAllReseauClients} from '../../../components/requests'
import {ModeleReseauClient} from '../../../components/Models'
import {toast} from 'react-toastify'

// Validation du formulaire de selection de reseau
const validate = (values) => {
  const errors: { reseauClient?: String } = {};
  // Si aucun reseau n'a été soumis
  if (values.reseauClient.length === 0) {
    errors.reseauClient = 'Ce champ est requis';
  }
  return errors
}
interface ReseauClientProps {
  clientId?: string | number | undefined
  data:any
  setData:any
}
/**
 * ReseauClientAffectModal
 *
 * Bouton et modal d'affectation d'un reseau à un client
 *
 * clientId : identifiant du client
 * data : la liste des reseaux du client
 * setData : method de modification manuelle de data après affecation ou desaffectation
 * */
const ReseauClientAffectModal = ({clientId = '', data, setData}:ReseauClientProps) => {
  const [allReseauClient, setAllReseauClient] = useState<Array<ModeleReseauClient>>([])
  const [reseauClient, setReseauClient] = useState<Array<any>>([])
  const [dataLoading, setDataLoading] = useState<boolean>(true)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const closeButton = useRef<any>()

  // Requête vers la base de données pour obtenir tout les reseaux client
  const getReseauClient = () => {
    getAllReseauClients().then(res => {
      if (res.data !== undefined && res.status === 200) {
        setAllReseauClient(res.data)
        // Formattage des resultats de la requêtes sous forme de label et valeur pour le selecteur multiple
        const formatedData = res.data.map(reseau => ({
          label: reseau.nom,
          value: reseau.id,
        }))
        // Données du selecteur multiple
        setReseauClient(formatedData)
      }
    }).catch((error) => {
      console.log('erreur')
    }).finally(() => {
      setDataLoading(false)
    })
  }

  // Method qui ajuste les données du selecteur multiple
  // retire / rajoute un reseau du client par rapport à ces reseaux déjà affectés
  const refreshReseauClient = () => {
    // Filtrer tous les reseaux par rapport aux reseaux dans data
    const reseauClientFiltered = allReseauClient
      .filter((reseauValue) => {
        return !data
          .some((reseau) =>
            reseauValue.id === reseau.id
          )
      })
    // Formattage des données filrés
    const formatReseauClient = reseauClientFiltered
      .map(reseau => ({
        label: reseau.nom,
        value: reseau.id,
      }))
    // Données du selecteur multiple
    setReseauClient(formatReseauClient)
  }

  const formik = useFormik({
    initialValues: {
      reseauClient: [],
    },
    validate,
    onSubmit: values => {
      // Activation du chargement de la soumission
      setIsLoading(true)
      // Activation du chargement de la liste des reseaux
      setDataLoading(true)
      // Activation du chargement du toast d'affectation
      const toastId = toast.loading('Affectation en cours', {position: "bottom-right"})
      // Formattage des données soumis sous forme de nombre séparé par virgule
      const reseauClientValue = values.reseauClient
        .map((reseau: { value: Number; label: string; }) => reseau.value)
        .join(',')
      // Si clientId est un nombre
      if (clientId !== '' && clientId !== undefined && clientId !== null) {
        // Requête d'affectation d'un reseau à un client
        affectReseauClient(clientId, reseauClientValue).then(res => {
          if (res.data === "Success" && res.status === 200) {
            // Filtrage de tous les reseaux par rapport aux données soumis
            const filteredData = allReseauClient
              .filter((reseau) => {
                return values.reseauClient
                  .some((reseauSubmited: { value: Number; label: string; }) =>
                    reseau.id === reseauSubmited.value
                  )
              })
            // Changement manuel de la data, ajout des données soumis
            setData(prev => [...prev, ...filteredData])
            toast.update(toastId, {
              render: 'Réseau client affecté avec succès',
              type: 'success',
              isLoading: false,
              autoClose: 3000,
            })
          }
        }).catch(error => {
          console.log('erreur')
          toast.update(toastId, {
            render: 'Erreur durant l\'affectation du réseau client',
            type: 'error',
            isLoading: false,
            autoClose: 3000,
          })
        }).finally(() => {
          setIsLoading(false)
          setDataLoading(false)
          closeButton.current.click()
        })
      } else {
        setIsLoading(false)
        setDataLoading(false)
        closeButton.current.click()
      }
      formik.resetForm()
    },
  });

  // useEffect qui liste tous les reseaux du client
  useEffect(() => {
    setDataLoading(true)
    if (clientId !== '') {
      getReseauClient()
    }
  }, [clientId]);

  // useEffect qui change la valeur de data apres affectation ou desaffectation
  useEffect(() => {
    refreshReseauClient()
  }, [data, allReseauClient]);

  // Style du select pour le selecteur multiple de réseau
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: '45px',
      minWidth: '200px',
      backgroundColor: 'transparent',
    }),
  };

  return (
    <>
      <div className='card-toolbar'>
        <button
          type="button"
          className="btn btn-sm btn-light-primary"
          data-bs-toggle="modal"
          data-bs-target="#reseauClientAffectModal"
        >
          <KTIcon iconName='plus' className='fs-3'/>
          Affecter un réseau client
        </button>
      </div>

      <div
        className="modal fade"
        id="reseauClientAffectModal"
        tabIndex={-1}
        aria-labelledby="reseauClientAffectModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>
                Affecter le client à un ou plusieurs réseaux
              </h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
                ref={closeButton}
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <form onSubmit={formik.handleSubmit}>
              <div className='modal-body'>
                <Select
                  id="reseauClient"
                  name="reseauClient"
                  className="basic-single"
                  classNamePrefix="select"
                  styles={customStyles}
                  isDisabled={dataLoading}
                  isLoading={dataLoading}
                  isClearable={true}
                  isSearchable={true}
                  isMulti={true}
                  placeholder={false}
                  options={reseauClient}
                  onChange={(data) => formik.setFieldValue("reseauClient", data)}
                  value={formik.values.reseauClient}
                />
                {formik.errors.reseauClient ?
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.reseauClient}</div>
                  </div> : null}
              </div>
              <div className='modal-footer'>
                <button
                  type='button'
                  className='btn btn-secondary'
                  data-bs-dismiss='modal'
                >
                  Annuler
                </button>
                <button
                  type='submit'
                  className='btn btn-primary'
                >
                  {(isLoading) ? (
                    <>
                      Enregistrement...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2 mt-n1'></span>
                    </>
                  ) : (
                    <>Enregistrer</>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export {ReseauClientAffectModal}